function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useRef, useEffect } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import MenuItem from '../menuItem';
export default function MenuItems(_ref) {
  var items = _ref.items,
    animation = _ref.animation,
    showMenuItems = _ref.showMenuItems,
    onClick = _ref.onClick,
    closeMenu = _ref.closeMenu,
    frontendStyles = _ref.frontendStyles;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    offset = _useState2[0],
    setOffset = _useState2[1];
  var _useState3 = useState(items),
    _useState4 = _slicedToArray(_useState3, 2),
    itemsToShow = _useState4[0],
    setItemsToShow = _useState4[1];
  var _useState5 = useState([items]),
    _useState6 = _slicedToArray(_useState5, 2),
    itemsStack = _useState6[0],
    setItemsStack = _useState6[1];
  var _useState7 = useState('next'),
    _useState8 = _slicedToArray(_useState7, 2),
    move = _useState8[0],
    changeMove = _useState8[1];
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    id = _useState10[0],
    setId = _useState10[1];
  var menuItemsRef = useRef(null);
  useEffect(function () {
    if (menuItemsRef.current && document.body.offsetWidth - menuItemsRef.current.offsetParent.offsetLeft < menuItemsRef.current.offsetWidth) {
      setOffset('right');
    } else if (menuItemsRef.current && document.body.offsetWidth - menuItemsRef.current.offsetParent.offsetLeft > menuItemsRef.current.offsetWidth) {
      setOffset('left');
    }
  }, []);
  var changeMenuItems = function changeMenuItems(newItemsToShow, newItemsStack, updatedMove, updatedId) {
    setItemsToShow(newItemsToShow);
    setItemsStack(newItemsStack);
    changeMove(updatedMove);
    setId(updatedId);
  };
  var moveToNext = function moveToNext(targetItem) {
    if (targetItem.items && targetItem.items.length > 0) {
      var newItems = itemsToShow.find(function (item) {
        return item.value === targetItem.value;
      });
      if (newItems !== undefined && 'items' in newItems && newItems.items.length > 0) {
        changeMenuItems(newItems.items, [].concat(_toConsumableArray(itemsStack), [itemsToShow]), 'next', Math.random().toString(36).substr(2, 9));
      }
    } else if (onClick) {
      onClick(targetItem, closeMenu);
    }
  };
  var moveToPrevious = function moveToPrevious() {
    var newItemsStack = _toConsumableArray(itemsStack);
    var newItemsToShow = newItemsStack.pop();
    if (newItemsToShow !== undefined) {
      changeMenuItems(newItemsToShow, newItemsStack, 'prev', Math.random().toString(36).substr(2, 9));
    }
  };
  var childFactoryCreator = function childFactoryCreator(classNames) {
    return function (child) {
      return /*#__PURE__*/React.cloneElement(child, {
        classNames: classNames
      });
    };
  };
  return /*#__PURE__*/React.createElement(TransitionGroup, {
    childFactory: childFactoryCreator(move === 'next' ? animation[0] : animation[1])
  }, /*#__PURE__*/React.createElement(CSSTransition, {
    timeout: 300,
    key: id
  }, /*#__PURE__*/React.createElement("div", {
    className: "menuItems ".concat(showMenuItems ? 'showMenuItems' : 'hideMenuItems'),
    ref: menuItemsRef,
    onClick: function onClick(event) {
      event.stopPropagation();
    },
    style: {
      backgroundColor: frontendStyles.burgerNavigation.background,
      color: frontendStyles.burgerNavigation.color,
      right: offset === 'right' ? 0 : 'unset',
      left: offset === 'left' ? 0 : 'unset'
    }
  }, itemsToShow.map(function (item) {
    var checkItem = item.value;
    if (checkItem === 'back') {
      return /*#__PURE__*/React.createElement("div", {
        className: "flex-box items-center pointer",
        style: {
          width: '100%',
          paddingLeft: 20,
          paddingRight: 20,
          paddingTop: 10,
          paddingBottom: 10
        },
        key: Math.random().toString(36).substr(2, 9),
        onClick: function onClick() {
          return moveToPrevious();
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "left_icon",
        style: {
          backgroundColor: frontendStyles.burgerNavigation.background,
          color: frontendStyles.burgerNavigation.color,
          paddingRight: 10
        }
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          backgroundColor: frontendStyles.burgerNavigation.background,
          color: frontendStyles.burgerNavigation.color
        }
      }, item.value));
    }
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: Math.random().toString(36).substr(2, 9),
      item: item,
      frontendStyles: frontendStyles,
      moveToNext: moveToNext,
      nextValue: item.hasOwnProperty('items') && item.items.length > 0
    });
  }))));
}